import { useEffect, useState } from 'react'

/**
 * The current time, re-read every `stepMs` while the caller is mounted — for the
 * "resets in 3 h 12 m" countdowns. It asks the BROWSER what time it is, never a
 * machine (noHeartbeat.test names it for that reason); nothing is fetched on the
 * tick, and the interval lives exactly as long as the component showing the clock.
 */
export function useClock(stepMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now() / 1000)
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now() / 1000), stepMs)
    return () => window.clearInterval(id)
  }, [stepMs])
  return now
}
